import DocumentPage from "../../../../invoice/DocumentPage";
import { siiSimplifiedInvoiceConfig } from "./config";

const SIISimplifiedInvoice = () => (
  <DocumentPage config={siiSimplifiedInvoiceConfig} />
);

export default SIISimplifiedInvoice;
